<template>
  <b-navbar type="dark" variant="primary">
    <div class="container">
      <b-navbar-brand href="#">  <img src="../../public/logo/white.png" alt="logo" /></b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <b-nav-item v-b-toggle.sidebar-1
          ><span class="navbar-toggler-icon"></span
        ></b-nav-item>
        <b-sidebar
          id="sidebar-1"
          :title="GetLoggedInUser"
          bg-variant="primary"
          text-variant="white"
          right
          shadow
        >
          <nav class="mb-3">
            <b-nav vertical>
              <div v-if="IsLoggedIn" >
                 <b-nav-item href="/"><h5  class="text-white">Home</h5 ></b-nav-item>
                 <b-nav-item href="/orders"><h5  class="text-white">All Orders</h5 ></b-nav-item>
                 <b-nav-item href="/collectorder"><h5  class="text-white">Order Collection</h5 ></b-nav-item> 
                 <b-nav-item @click="SignOut" href="#"><h5  class="text-white">Log Out</h5 ></b-nav-item>
              </div>
              <div v-else>
                <b-nav-item href="/login"><h5  class="text-white">Sign In</h5 ></b-nav-item>
                <b-nav-item v-bind:href="register"><h5  class="text-white">Sign Up</h5 ></b-nav-item>
              </div>

            </b-nav>
          </nav>
        </b-sidebar>
      </b-navbar-nav>
    </div>
  </b-navbar>

</template>
<script>
import { userAuth } from "../services/security";
import config from "@/settings/config.js";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

export default {
  components: {
    Loading,
  },
  data: function () {
    return {
      isLoading: true,
      fullPage: true,
      Message: "Welcome to umbai",
    };
  },
  computed: {
    IsLoggedIn: function () {
      if (userAuth.data().user.isAuthenticated) {
         return true
      }
      return false;
    },
    GetLoggedInUser: function () {
      return userAuth.GetUserName();
    },
  },
  methods: {
    SignIn: async function () {
      await userAuth.signIn("/users");
    },
    SignOut: async function () {
      await userAuth.SignOut();
    },
  },
};
</script>
<style>
</style>